import { env } from '@/env/client'
import { getAbsoluteUrl } from '@/utils/url'

const baseUrl = env.NEXT_PUBLIC_BASE_URL

const supportEmail = 'support@backlinkgpt.com'

export const siteConfig = {
  name: 'BacklinkGPT',
  url: baseUrl,
  appUrl: getAbsoluteUrl('/app'),
  logo: getAbsoluteUrl('/og/logo.png'),
  // TODO
  ogImage: getAbsoluteUrl('/og/banner.jpg'),
  supportEmail,
  mainEmail: 'hello@mail.backlinkgpt.com',
  noreplyEmail: 'noreply@mail.backlinkgpt.com',
  organization: 'BacklinkGPT',
  organizationUrl: 'https://backlinkgpt.com',
  // TODO: Update
  links: {
    mailtoSupport: `mailto:${supportEmail}`,
    twitter: 'https://twitter.com/felixvemmer',
    whatsapp: 'https://wa.me/4915776813593',
    github: 'https://github.com/feliche93/backlinkgpt',
    linkedin: 'https://www.linkedin.com/in/felix-vemmer/',
  },
}

export type SiteConfig = typeof siteConfig
